var _style, _defs, _defs2, _g, _g2, _g3, _g4, _g5, _g6, _defs3, _path, _g7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGsap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{display:inline;clip-path:url(#SVGID_00000002352666496624239940000014341138475147430016_);fill:#264DE4;}\n\t.st3{display:inline;clip-path:url(#SVGID_00000002352666496624239940000014341138475147430016_);fill:#2965F1;}\n\t.st4{display:inline;clip-path:url(#SVGID_00000002352666496624239940000014341138475147430016_);fill:#EBEBEB;}\n\t.st5{display:inline;clip-path:url(#SVGID_00000002352666496624239940000014341138475147430016_);fill:#FFFFFF;}\n\t.st6{display:inline;clip-path:url(#SVGID_00000169529849729680258040000011283831013021453995_);fill:#E44D26;}\n\t.st7{display:inline;clip-path:url(#SVGID_00000169529849729680258040000011283831013021453995_);fill:#F16529;}\n\t.st8{display:inline;clip-path:url(#SVGID_00000169529849729680258040000011283831013021453995_);fill:#EBEBEB;}\n\t.st9{display:inline;clip-path:url(#SVGID_00000169529849729680258040000011283831013021453995_);fill:#FFFFFF;}\n\t.st10{display:inline;fill:#F7DF1E;}\n\t.st11{display:inline;fill:#61DAFB;}\n\t.st12{fill:none;stroke:#61DAFB;stroke-width:4;}\n\t.st13{fill-rule:evenodd;clip-rule:evenodd;fill:#21609B;}\n\t.st14{display:inline;fill:#F05133;}\n\t.st15{fill:#00E559;}\n\t.st16{display:inline;fill:#3178C6;}\n\t.st17{display:inline;fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st18{clip-path:url(#SVGID_00000052080125252613368130000006161943000049049757_);}\n\t.st19{fill-rule:evenodd;clip-rule:evenodd;fill:#38BDF8;}\n\t.st20{display:inline;fill:#FFFFFF;}\n\t.st21{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\n\t.st22{fill:#FFFFFF;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M76.15,82.5h-52.3c-3.51,0-6.35-2.84-6.35-6.35v-52.3c0-3.51,2.84-6.35,6.35-6.35h52.3 c3.51,0,6.35,2.84,6.35,6.35v52.3C82.5,79.66,79.66,82.5,76.15,82.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000048467915129382644180000000144109485400774333_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      clipPath: "url(#SVGID_00000048467915129382644180000000144109485400774333_)",
      fill: "#264DE4"
    },
    d: " M16.32,88.3L8.93,5.5h81.12l-7.39,82.79L49.45,97.5L16.32,88.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      clipPath: "url(#SVGID_00000048467915129382644180000000144109485400774333_)",
      fill: "#2965F1"
    },
    d: " M89.5,91.5l-6.85-79.23H49.5v78.19L89.5,91.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      clipPath: "url(#SVGID_00000048467915129382644180000000144109485400774333_)",
      fill: "#EBEBEB"
    },
    d: " M29.89,44.38l0.75,8.42h18.84v-8.42H29.89z M29.14,35.76h20.35v-8.42H28.37L29.14,35.76z M49.49,66.25l-0.04,0.01l-9.38-2.53 l-0.6-6.72h-8.45l1.18,13.22l17.25,4.79l0.04-0.01L49.49,66.25z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      clipPath: "url(#SVGID_00000048467915129382644180000000144109485400774333_)",
      fill: "#FFFFFF"
    },
    d: " M49.46,44.38v8.42h10.37l-0.98,10.92l-9.39,2.53v8.76l17.26-4.78l0.13-1.42l1.98-22.17l0.21-2.26l1.52-17.04H49.46v8.42h11.87 l-0.77,8.62H49.46z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000011752992355224256060000005071467950260594337_",
    d: "M76.15,82.5h-52.3c-3.51,0-6.35-2.84-6.35-6.35v-52.3 c0-3.51,2.84-6.35,6.35-6.35h52.3c3.51,0,6.35,2.84,6.35,6.35v52.3C82.5,79.66,79.66,82.5,76.15,82.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000134228751892423354540000008883751138437108399_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000011752992355224256060000005071467950260594337_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      clipPath: "url(#SVGID_00000134228751892423354540000008883751138437108399_)",
      fill: "#E44D26"
    },
    d: " M16.31,88.33L8.93,5.5h81.13l-7.38,82.79L49.43,97.5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      clipPath: "url(#SVGID_00000134228751892423354540000008883751138437108399_)",
      fill: "#F16529"
    },
    d: " M49.5,90.46V12.3h33.16l4.84,75.2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      clipPath: "url(#SVGID_00000134228751892423354540000008883751138437108399_)",
      fill: "#EBEBEB"
    },
    d: " M28.41,27.41h21.08v8.4H37.62l0.78,8.6h11.1v8.38H30.7 M31.07,57h8.43l0.59,6.71l9.39,2.52v8.77l-17.24-4.81"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      clipPath: "url(#SVGID_00000134228751892423354540000008883751138437108399_)",
      fill: "#FFFFFF"
    },
    d: " M70.5,27.41H49.46v8.4h20.27 M68.97,44.4H49.46v8.4h10.36l-0.98,10.91l-9.38,2.52v8.73l17.2-4.77"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M23.85,17.5h52.3c3.51,0,6.35,2.84,6.35,6.35v52.3c0,3.51-2.84,6.35-6.35,6.35h-52.3 c-3.51,0-6.35-2.84-6.35-6.35v-52.3C17.5,20.34,20.34,17.5,23.85,17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M61.16,68.28c1.31,2.14,3.01,3.71,6.03,3.71c2.53,0,4.15-1.26,4.15-3.01c0-2.09-1.66-2.84-4.45-4.05 l-1.53-0.66c-4.41-1.88-7.34-4.23-7.34-9.2c0-4.58,3.49-8.07,8.95-8.07c3.88,0,6.68,1.35,8.69,4.89l-4.76,3.05 c-1.05-1.88-2.18-2.62-3.93-2.62c-1.79,0-2.92,1.13-2.92,2.62c0,1.83,1.13,2.57,3.76,3.71l1.53,0.65c5.19,2.23,8.12,4.49,8.12,9.6 c0,5.5-4.32,8.51-10.12,8.51c-5.67,0-9.34-2.7-11.13-6.25L61.16,68.28z M39.59,68.81c0.96,1.7,1.83,3.14,3.93,3.14 c2.01,0,3.27-0.79,3.27-3.84V47.35h6.11V68.2c0,6.32-3.71,9.2-9.12,9.2c-4.89,0-7.72-2.53-9.16-5.58L39.59,68.81z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 50,
    cy: 50,
    r: 7.27
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st12",
    cx: 50,
    cy: 50,
    rx: 39,
    ry: 14.89
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.866 -0.5 0.5 0.866 -18.3013 31.6987)",
    className: "st12",
    cx: 50,
    cy: 50,
    rx: 14.89,
    ry: 39
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5 -0.866 0.866 0.5 -18.3013 68.3013)",
    className: "st12",
    cx: 50,
    cy: 50,
    rx: 39,
    ry: 14.89
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M82.83,66.53l-0.31,0.8c-5.25,10.23-14.56,16.5-27.83,16.78c-6.21,0.13-12.12-1.46-15.98-3.2 c-8.34-3.75-15.35-10.69-19.18-18.11c-5.49-10.64-6.48-25.44,4.94-36.49c0.18,0-1.39,2.4-1.21,2.4l-0.31,1.02 c-8.23,25.77,17.13,47.85,41.77,45.32C70.64,74.44,78.2,71.2,82.83,66.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M67.92,55.87c6.2,0.04,12.68-2.86,16.51-6.92c-3.36,8.52-13.07,13.99-26.1,12.25 c-10.91-1.46-21.3-12.44-22.37-23.44c-0.78-8.01,2.01-12.78,6.6-18.58c-1.6,3.03-2.2,5.37-2.34,6.86 C38.47,43.36,54.05,55.78,67.92,55.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M83.81,34.36c-0.96,2.21-6.51,6.39-8.96,6.91c-9.71,2.07-15.92-2.53-19.18-7.77 c-0.48-0.78-1.38-2.92-1.54-3.46c-1.26-4.29-0.68-10.79,3.08-14.15c-1.13,3.2-1.3,6.91-0.7,9.32c0.36,1.46,1.46,4.01,2.57,5.61 c2.01,2.92,3.28,3.63,5.86,5.18c1.16,0.7,2.41,1.26,2.95,1.41C70.32,38.13,75.49,40.02,83.81,34.36"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M86.25,46.64L53.35,13.75c-1.89-1.89-4.97-1.89-6.86,0l-6.83,6.83l8.66,8.66c2.01-0.68,4.32-0.22,5.93,1.38 c1.61,1.62,2.07,3.94,1.37,5.96l8.35,8.35c2.02-0.7,4.35-0.25,5.96,1.37c2.25,2.25,2.25,5.91,0,8.16c-2.26,2.26-5.91,2.26-8.17,0 c-1.7-1.7-2.12-4.19-1.26-6.28l-7.79-7.79v20.49c0.55,0.27,1.07,0.63,1.53,1.09c2.25,2.25,2.25,5.91,0,8.16 c-2.25,2.25-5.91,2.25-8.16,0c-2.25-2.26-2.25-5.91,0-8.16c0.56-0.56,1.2-0.98,1.89-1.26V40.05c-0.69-0.28-1.33-0.7-1.89-1.26 c-1.71-1.71-2.12-4.21-1.24-6.31l-8.54-8.54L13.75,46.49c-1.89,1.9-1.89,4.97,0,6.86l32.89,32.89c1.89,1.89,4.97,1.89,6.86,0 l32.74-32.74C88.14,51.61,88.14,48.54,86.25,46.64z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path32",
    className: "st15",
    d: "M50.8,43.21c-0.01,0.32-0.27,0.57-0.59,0.57h-6.04c-0.4,0-0.73-0.32-0.73-0.71 c0-1.76-0.61-2.62-1.86-2.62c-1.25,0-2.05,0.77-2.07,2.1c-0.03,1.49,0.82,2.85,3.22,5.17c3.16,2.97,4.43,5.59,4.37,9.06 c-0.1,5.61-3.92,9.24-9.73,9.24c-2.97,0-5.23-0.79-6.74-2.36c-1.53-1.59-2.23-3.92-2.08-6.93c0.01-0.32,0.27-0.57,0.59-0.57h6.24 c0.18,0,0.34,0.08,0.45,0.22c0.1,0.11,0.14,0.26,0.11,0.41c-0.07,1.09,0.12,1.9,0.55,2.35c0.27,0.29,0.66,0.44,1.13,0.44 c1.15,0,1.83-0.81,1.85-2.23c0.02-1.23-0.37-2.3-2.48-4.48c-2.73-2.67-5.18-5.42-5.1-9.76c0.04-2.51,1.04-4.81,2.81-6.47 c1.87-1.76,4.43-2.68,7.4-2.68c2.97,0.02,5.23,0.87,6.7,2.52C50.2,38.05,50.87,40.32,50.8,43.21L50.8,43.21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34",
    className: "st15",
    d: "M69.5,64.98l0.04-29.86c0-0.31-0.24-0.56-0.55-0.57c0,0-0.01,0-0.01,0h-9.34 c-0.31,0-0.45,0.27-0.54,0.45L45.57,64.8v0.01l-0.01,0.01c-0.15,0.37,0.13,0.76,0.53,0.76h6.53c0.35,0,0.59-0.11,0.7-0.33l1.3-3.12 c0.16-0.42,0.19-0.45,0.64-0.45h6.24c0.43,0,0.44,0.01,0.44,0.43L61.8,65c0,0.31,0.24,0.56,0.55,0.57c0,0,0.01,0,0.01,0h6.6 c0.17,0,0.32-0.07,0.43-0.19C69.48,65.26,69.53,65.12,69.5,64.98L69.5,64.98z M57.95,55.01c-0.05,0-0.1,0-0.15-0.01 c-0.09-0.01-0.15-0.08-0.14-0.17c0-0.01,0-0.02,0-0.03c0.01-0.04,0.03-0.1,0.06-0.17l4.68-11.57c0.04-0.11,0.09-0.23,0.15-0.33 c0.08-0.16,0.17-0.17,0.2-0.05c0.02,0.1-0.54,11.88-0.54,11.88c-0.04,0.44-0.06,0.46-0.5,0.5L57.95,55.01L57.95,55.01L57.95,55.01 L57.95,55.01z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path36",
    className: "st15",
    d: "M82.81,34.55h-4.96c-0.26,0-0.56,0.14-0.62,0.45l-6.9,29.96c-0.03,0.14,0,0.28,0.09,0.39 c0.12,0.14,0.29,0.22,0.47,0.22h6.2c0.33,0,0.56-0.16,0.62-0.45l0.75-3.4c0.05-0.27-0.04-0.47-0.28-0.59 c-0.11-0.06-0.22-0.12-0.33-0.17l-1.07-0.56l-1.07-0.56l-0.41-0.21c-0.07-0.03-0.11-0.1-0.11-0.18c0-0.12,0.1-0.21,0.21-0.21 l3.4,0.01c1.02,0.01,2.03-0.07,3.03-0.25c7.03-1.3,11.7-6.93,11.84-14.6C93.78,37.86,90.13,34.55,82.81,34.55L82.81,34.55z  M81.12,52.38h-0.13c-0.3,0-0.35-0.03-0.36-0.04c-0.01-0.01,1.96-8.63,1.96-8.64c0.05-0.25,0.05-0.39-0.11-0.48 c-0.2-0.11-3.06-1.62-3.06-1.62c-0.07-0.04-0.11-0.11-0.11-0.18c0-0.11,0.1-0.21,0.21-0.21h4.53c1.41,0.04,2.2,1.31,2.16,3.46 C86.15,48.4,84.38,52.25,81.12,52.38L81.12,52.38z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g71",
    transform: "matrix(12.23983,0,0,12.23983,0.00428872,0.83231)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path60",
    className: "st15",
    d: "M2.6,3.94L2.6,3.94L2.5,4.35C2.5,4.37,2.47,4.39,2.45,4.39H2.33c-0.01,0-0.02,0.01-0.02,0.01 C2.21,4.75,2.07,5,1.88,5.14C1.72,5.27,1.53,5.33,1.27,5.33c-0.24,0-0.39-0.08-0.53-0.23C0.56,4.9,0.49,4.58,0.53,4.19 c0.08-0.73,0.46-1.47,1.19-1.47c0.22,0,0.4,0.07,0.52,0.2c0.13,0.14,0.19,0.36,0.19,0.65c0,0.03-0.02,0.05-0.05,0.05H1.85 c-0.02,0-0.04-0.02-0.04-0.04c0-0.2-0.06-0.29-0.18-0.29c-0.21,0-0.33,0.28-0.39,0.43C1.15,3.94,1.11,4.17,1.12,4.41 c0,0.11,0.02,0.26,0.12,0.32c0.09,0.06,0.22,0.02,0.3-0.04c0.08-0.06,0.14-0.17,0.17-0.27c0-0.01,0-0.02,0-0.03 c0,0-0.01-0.01-0.02-0.01H1.55c-0.01,0-0.03-0.01-0.04-0.02C1.51,4.36,1.5,4.35,1.51,4.34L1.6,3.93c0-0.02,0.02-0.04,0.05-0.04v0 h0.9c0,0,0,0,0.01,0C2.58,3.89,2.6,3.91,2.6,3.94L2.6,3.94L2.6,3.94z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M23.85,17.5h52.3c3.51,0,6.35,2.84,6.35,6.35v52.3c0,3.51-2.84,6.35-6.35,6.35h-52.3 c-3.51,0-6.35-2.84-6.35-6.35v-52.3C17.5,20.34,20.34,17.5,23.85,17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M23.85,17.5h52.3c3.51,0,6.35,2.84,6.35,6.35v52.3c0,3.51-2.84,6.35-6.35,6.35h-52.3 c-3.51,0-6.35-2.84-6.35-6.35v-52.3C17.5,20.34,20.34,17.5,23.85,17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M57.74,69.22v6.36c1.03,0.53,2.26,0.93,3.67,1.19c1.41,0.26,2.9,0.4,4.46,0.4c1.52,0,2.97-0.15,4.34-0.44 c1.37-0.29,2.57-0.77,3.61-1.44c1.03-0.67,1.85-1.54,2.45-2.62s0.9-2.41,0.9-4c0-1.15-0.17-2.16-0.52-3.03 c-0.34-0.87-0.84-1.64-1.49-2.31c-0.65-0.68-1.43-1.28-2.33-1.82c-0.91-0.54-1.93-1.04-3.07-1.52c-0.83-0.34-1.58-0.68-2.25-1 c-0.66-0.32-1.23-0.66-1.69-0.99c-0.46-0.34-0.82-0.7-1.07-1.07c-0.25-0.38-0.38-0.8-0.38-1.28c0-0.44,0.11-0.83,0.34-1.18 c0.23-0.35,0.54-0.65,0.95-0.9c0.41-0.25,0.91-0.45,1.51-0.59c0.6-0.14,1.26-0.21,1.99-0.21c0.53,0,1.09,0.04,1.68,0.12 c0.59,0.08,1.18,0.2,1.78,0.37c0.6,0.17,1.18,0.37,1.74,0.63c0.56,0.25,1.08,0.54,1.56,0.87v-5.94c-0.97-0.37-2.02-0.65-3.17-0.82 c-1.15-0.18-2.46-0.27-3.94-0.27c-1.51,0-2.94,0.16-4.29,0.49c-1.35,0.32-2.54,0.83-3.57,1.52c-1.03,0.69-1.84,1.57-2.43,2.63 c-0.6,1.07-0.89,2.34-0.89,3.82c0,1.89,0.55,3.51,1.64,4.85c1.09,1.34,2.75,2.47,4.98,3.4c0.87,0.36,1.69,0.71,2.44,1.05 c0.75,0.34,1.41,0.7,1.96,1.07c0.55,0.37,0.98,0.77,1.3,1.21c0.32,0.44,0.48,0.93,0.48,1.49c0,0.41-0.1,0.79-0.3,1.14 c-0.2,0.35-0.5,0.66-0.9,0.91c-0.4,0.26-0.91,0.46-1.51,0.61c-0.6,0.15-1.31,0.22-2.12,0.22c-1.38,0-2.74-0.24-4.09-0.72 C60.14,70.92,58.89,70.19,57.74,69.22L57.74,69.22z M47.05,53.57h8.15v-5.22H32.48v5.22h8.11v23.22h6.46V53.57z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000139277448792456277020000006543177287394207652_",
    x: 10.19,
    y: 26.11,
    width: 79.63,
    height: 47.78
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000146489668313569505880000017575351129425637017_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000139277448792456277020000006543177287394207652_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146489668313569505880000017575351129425637017_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M50,26.11c-10.62,0-17.25,5.31-19.91,15.93c3.98-5.31,8.63-7.3,13.94-5.97c3.03,0.76,5.19,2.96,7.59,5.39 c3.9,3.96,8.42,8.55,18.29,8.55c10.62,0,17.25-5.31,19.91-15.93c-3.98,5.31-8.63,7.3-13.94,5.97c-3.03-0.76-5.19-2.96-7.59-5.39 C64.39,30.7,59.87,26.11,50,26.11z M30.09,50c-10.62,0-17.25,5.31-19.91,15.93c3.98-5.31,8.63-7.3,13.94-5.97 c3.03,0.76,5.19,2.96,7.59,5.39c3.9,3.96,8.42,8.55,18.29,8.55c10.62,0,17.25-5.31,19.91-15.93c-3.98,5.31-8.63,7.3-13.94,5.97 c-3.03-0.76-5.19-2.96-7.59-5.39C44.48,54.59,39.96,50,30.09,50z"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st20",
    points: "32.97,87.23 14.7,14.59 86.95,34.87  "
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st21",
    x1: 41.92,
    y1: 56.01,
    x2: 46.49,
    y2: 74.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "st21",
    x1: 59.95,
    y1: 61.12,
    x2: 41.92,
    y2: 56.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "st21",
    x1: 46.49,
    y1: 74.18,
    x2: 59.95,
    y2: 61.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M28.46,69.08"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st21",
    x1: 46.49,
    y1: 74.18,
    x2: 28.46,
    y2: 69.08
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M28.46,69.08"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st21",
    points: "28.46,69.08 33.02,87.26 46.49,74.18  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st21",
    x1: 28.46,
    y1: 69.08,
    x2: 41.92,
    y2: 56.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "st21",
    x1: 41.92,
    y1: 56.01,
    x2: 55.4,
    y2: 42.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st21",
    x1: 55.4,
    y1: 42.94,
    x2: 68.86,
    y2: 29.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "st21",
    x1: 50.83,
    y1: 24.77,
    x2: 55.4,
    y2: 42.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st21",
    x1: 55.4,
    y1: 42.94,
    x2: 37.36,
    y2: 37.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "st21",
    x1: 37.36,
    y1: 37.84,
    x2: 41.92,
    y2: 56.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "st21",
    x1: 41.92,
    y1: 56.01,
    x2: 23.9,
    y2: 50.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "st21",
    x1: 23.9,
    y1: 50.91,
    x2: 28.46,
    y2: 69.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "st21",
    x1: 19.33,
    y1: 32.74,
    x2: 23.9,
    y2: 50.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "st21",
    x1: 37.36,
    y1: 37.84,
    x2: 19.33,
    y2: 32.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "st21",
    x1: 23.9,
    y1: 50.91,
    x2: 37.36,
    y2: 37.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "st21",
    x1: 37.36,
    y1: 37.83,
    x2: 50.83,
    y2: 24.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "st21",
    x1: 50.83,
    y1: 24.77,
    x2: 32.79,
    y2: 19.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "st21",
    x1: 32.79,
    y1: 19.66,
    x2: 37.36,
    y2: 37.83
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st21",
    points: "19.33,32.74 14.77,14.56 32.79,19.66  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st21",
    x1: 19.33,
    y1: 32.74,
    x2: 32.79,
    y2: 19.66
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st21",
    points: "73.42,48.04 86.88,34.98 68.86,29.87  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st21",
    x1: 68.86,
    y1: 29.87,
    x2: 73.42,
    y2: 48.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "st21",
    x1: 73.42,
    y1: 48.04,
    x2: 55.4,
    y2: 42.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st21",
    x1: 55.4,
    y1: 42.94,
    x2: 59.95,
    y2: 61.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "st21",
    x1: 59.95,
    y1: 61.12,
    x2: 73.42,
    y2: 48.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "st21",
    x1: 68.86,
    y1: 29.87,
    x2: 50.83,
    y2: 24.77
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGsap);
export default __webpack_public_path__ + "static/media/GSAP.1917260c699544d9562b8a083033ca91.svg";
export { ForwardRef as ReactComponent };